<template>
    <v-card class="mb-3">
        <v-card-title>
            <v-layout row justify-space-between>
                <div class="title">{{title | capitalize}}</div>
                <v-btn color="primary" @click="exportReport">{{this.$t('exportReport')}}</v-btn>
            </v-layout>
        </v-card-title>
        <v-card-text>
            <v-layout row ma-0 justify-space-between>
                <v-layout>
                    <DatePicker
                        v-model="fromDate"
                        :label="$filters.capitalize($t('from'))"
                        :max="toDate"
                    ></DatePicker>
                    <div style="width: 5px"></div>
                    <DatePicker
                        v-model="toDate"
                        :label="$filters.capitalize($t('to'))"
                        :min="fromDate"
                        :max="today"
                    ></DatePicker>
                </v-layout>
                <div class="centerY">
                    <v-btn @click="update" class="ma-0 ml-3">{{$t('update')}}</v-btn>
                </div>
            </v-layout>
            <SimpleDataTable
                :headers="headers"
                :items="dataTable"
            ></SimpleDataTable>
        </v-card-text>
    </v-card>
</template>

<script>
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'
import DatePicker from '@/modules/fptai/components/DatePicker'
import moment from 'moment'
import Excel from 'exceljs'

export default {
    name: 'TopActiveBase',
    components: { SimpleDataTable, DatePicker },
    data () {
        return {
            dataTable: [],
            fromDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            max: 10
        }
    },
    computed: {
        title () {
            return ''
        },
        sheetName () {
            return ''
        },
        headers () {
            return []
        }
    },
    mounted () {
        this.update()
    },
    methods: {
        update () {
            // to be implemented by inheritor
        },
        addWorkSheet (workbook) {
            // columns
            let columns = []
            for (let header of this.headers) {
                columns.push({ name: header.text })
            }
            // rows
            let rows = []
            for (let item of this.dataTable) {
                let rowData = []
                for (let header of this.headers) {
                    rowData.push(item[header.value])
                }
                rows.push(rowData)
            }
            // add worksheet
            let ws = workbook.addWorksheet(this.sheetName)
            ws.getColumn('A').width = 30
            ws.getColumn('B').width = 30
            ws.getColumn('C').width = 30
            // title
            ws.getCell('A1').value = this.$filters.capitalize(this.title)
            ws.getCell('A1').font = { bold: true, size: 20 }
            // from date
            ws.getCell('A3').value = this.$filters.capitalize(this.$t('from'))
            ws.getCell('A3').font = { bold: true }
            ws.getCell('B3').value = this.fromDate
            // to date
            ws.getCell('A4').value = this.$filters.capitalize(this.$t('to'))
            ws.getCell('A4').font = { bold: true }
            ws.getCell('B4').value = this.toDate
            // table
            ws.addTable({
                name: this.sheetName.split(' ').join('_'),
                ref: 'A6',
                headerRow: true,
                columns: columns,
                rows: rows
            })
        },
        exportReport () {
            let workbook = new Excel.Workbook()
            this.addWorkSheet(workbook)
            workbook.xlsx.writeBuffer().then((data) => {
                this.$utils.downloadFileFromBlob(data, this.sheetName + '.xlsx')
            })
        }
    }
}
</script>

<style scoped>

</style>
